import * as React from 'react'
import { SVGProps } from 'react'
const SvgUbuntu = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={40} cy={6} r={5} fill="currentColor" />
    <circle cx={6} cy={24} r={5} fill="currentColor" />
    <circle cx={38} cy={42} r={5} fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5 6c1.943 0 3.811.317 5.557.9a7.001 7.001 0 0 0 8.339 5.96A17.424 17.424 0 0 1 45 23.5c0 4.595-1.77 8.776-4.667 11.898a7.002 7.002 0 0 0-9.197 5.224A17.565 17.565 0 0 1 27.5 41c-7.739 0-14.305-5.023-16.614-11.987A6.98 6.98 0 0 0 13 24c0-2.082-.91-3.952-2.352-5.234C12.713 11.4 19.476 6 27.5 6ZM41 23.5C41 30.956 34.956 37 27.5 37S14 30.956 14 23.5 20.044 10 27.5 10 41 16.044 41 23.5Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgUbuntu
